import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewUnit.GeneralUnitInformation.Title',
    defaultMessage: 'General Unit Information',
  },
  ADAUnit: {
    id: 'App.ViewUnit.GeneralUnitInformation.ADAUnit',
    defaultMessage: 'ADA Unit',
  },
  accessibilityTypes: {
    id: 'App.ViewUnit.GeneralUnitInformation.AccessibilityTypes',
    defaultMessage: 'Accessibility Types',
  },
  marketingDescription: {
    id: 'App.ViewUnit.GeneralUnitInformation.MarketingDescription',
    defaultMessage: 'Marketing Description',
  },
  grossSqFt: {
    id: 'App.ViewUnit.GeneralUnitInformation.GrossSqFt',
    defaultMessage: 'Floor Plan Gross SqFt',
  },
  unitAddress: {
    id: 'App.ViewUnit.GeneralUnitInformation.UnitAddress',
    defaultMessage: 'Unit Address',
  },
  unitEditButton: {
    id: 'App.ViewUnit.GeneralUnitInformation.UnitEditButton',
    defaultMessage: 'Edit',
  },
  unitLevel: {
    id: 'App.ViewUnit.GeneralUnitInformation.UnitLevel',
    defaultMessage: 'Unit Level',
  },
  unitFloorLevel: {
    id: 'App.ViewUnit.GeneralUnitInformation.UnitFloorLevel',
    defaultMessage: 'Unit Floor Level',
  },
  baseMarketRentAmount: {
    id: 'App.ViewUnit.GeneralUnitInformation.BaseMarketRentAmount',
    defaultMessage: 'Floorplan Market Rent Amount',
  },
  quotingRentAmount: {
    id: 'App.ViewUnit.GeneralUnitInformation.QuotingRentAmount',
    defaultMessage: 'Floorplan Quoting Rent Amount',
  },
  unitQuotingRentAmount: {
    id: 'App.ViewUnit.GeneralUnitInformation.UnitQuotingRentAmount',
    defaultMessage: 'Unit Quoting Rent Amount',
  },
  estimatedDepositAmount: {
    id: 'App.ViewUnit.GeneralUnitInformation.EstimatedDepositAmount',
    defaultMessage: 'Estimated Deposit Amount',
  },
  sqFt: {
    id: 'App.ViewUnit.GeneralUnitInformation.SqFt',
    defaultMessage: 'SqFt',
  },
  buildingName: {
    id: 'App.ViewUnit.GeneralUnitInformation.BuildingName',
    defaultMessage: 'Building',
  },
  xmlAltUnitNumber: {
    id: 'App.ViewUnit.GeneralUnitInformation.xmlAltUnitNumber',
    defaultMessage: 'Alternative Unit Name (XML)',
  },
  phUnitNumber: {
    id: 'App.ViewUnit.GeneralUnitInformation.phUnitNumber',
    defaultMessage: 'PH Unit Number',
  },
  hudUnitNumber: {
    id: 'App.ViewUnit.GeneralUnitInformation.hudUnitNumber',
    defaultMessage: 'HUD Unit #',
  },
  hudUnitNumberTooltip: {
    id: 'App.ViewUnit.GeneralUnitInformation.hudUnitNumberTooltip',
    defaultMessage:
      'If the Fortress Unit # differs from the HUD contract Unit #, ' +
      'please enter it here to ensure your Voucher sends the HUD Unit # to TRACS.',
  },
  unitQuotingRentAmountTooltip: {
    id: 'App.ViewUnit.GeneralUnitInformation.UnitQuotingRentAmountTooltip',
    defaultMessage: 'Adjust base rent only',
  },
});

export default messages;
